import React from 'react';

const Contact = ({ data }) => {
    return (
      <section id="contact">
         <div className="widget widget_contact">
         <h2>Let's work together...</h2>
         <p className="address">
            <a href="https://github.com/ashrithapb" target="_blank" rel="noopener noreferrer">GitHub</a><br/>
            <a href="https://www.linkedin.com/in/ashritha-pb/" target="_blank" rel="noopener noreferrer"> LinkedIn</a>
            <p>{data?.email}<br/> {data?.phone}</p>
         </p>
         </div>

         <div className="widget widget_tweets">

         </div>
   </section>
    );
}

export default Contact;
